import CopyFieldToClipboard from '../components/CopyFieldToClipboard'

export default class AdDesignJobsAssetPreviews {
  constructor(params) {}

  show() {
    new CopyFieldToClipboard();
  }
}
